import React, { useEffect, useState } from 'react';
import { stickyCtaLine, coachCtaHref } from '../../lib/publicProfile';

/**
 * The mobile-only bottom coach CTA.
 *
 * Visibility is driven by an IntersectionObserver on the hero's own primary
 * button (via `observeRef`) rather than a scroll threshold: hero height
 * varies with name wrapping, position count and whether there is a photo, so
 * any fixed pixel value (the mobile handoff's `window.scrollY > ~520px`)
 * would show this bar while the hero CTA was still on screen for short
 * heroes and delay it for tall ones. Doubling the CTA is the one thing the
 * design says must not happen.
 *
 * Hidden above 640px by CSS (`.ed-pp__sticky { display: none; }`), so it
 * costs nothing on desktop.
 */
export default function StickyCta({ athlete, isCoach, observeRef }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = observeRef && observeRef.current;
    // jsdom (the Jest test environment) has no IntersectionObserver, and a
    // page still rendering while the ref hasn't attached yet has no target
    // either. Either way, stay hidden rather than throw.
    if (!target || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [observeRef]);

  const href = coachCtaHref(athlete, isCoach);
  const label = isCoach ? 'View Full Recruiting File' : 'See Full Profile';

  return (
    <div className={`ed-pp__sticky${visible ? ' ed-pp__sticky--in' : ''}`}>
      <div className="ed-pp__sticky-id">
        <span className="ed-pp__sticky-name">{stickyCtaLine(athlete)}</span>
        <span className="ed-pp__sticky-sub">
          {isCoach ? 'Open the full recruiting file' : 'Coach login for full profile'}
        </span>
      </div>
      <a className="ed-pp__btn ed-pp__btn--primary ed-pp__sticky-btn" href={href}>
        {label}
      </a>
    </div>
  );
}
